export const    BUY_PRODUCT_DIGITAL = 'BUY_PRODUCT_DIGITAL';
export const    REMOVE_PRODUCT_DIGITAL = 'REMOVE_PRODUCT_DIGITAL';
export const    DELETE_PRODUCT_DIGITAL = 'DELETE_PRODUCT_DIGITAL';

